export type GemaTimingEvent = "interaction_intent" | "meal_intent" | "post_confirmed" | "moment_published" | "clip_requested" | "first_frame";
export type GemaTimingSource = "home" | "onboarding" | "personalizar";
export interface GemaTimingMeta {
  playbackId?: number;
  source?: GemaTimingSource;
  action?: string;
  prepared?: boolean;
}

let interactionSequence = 0;
export const nextGemaInteractionId = () => ++interactionSequence;

/** Development-only timings. Values contain no account, meal or personal identifiers. */
export function markGemaTiming(event: GemaTimingEvent, meta: GemaTimingMeta = {}) {
  if (!import.meta.env.DEV || import.meta.env.MODE === "test" || typeof performance === "undefined") return;
  const at = performance.now();
  performance.mark(`gema:${event}`);
  console.debug("[Gema timing]", { event, at: Math.round(at), ...meta });
}
